export default {
	section_banner: {
		title: {
			one: 'Request',
		},
		main_title: {
			one: 'Conveniently',
		},
		paragraph: {
			one: 'Friends and family can request cryptocurrency privately, instantly, and without notification.',
		},
		cta_buttons: {
			one: 'Cryptocurrency Request',
			two: 'Download App',
		},
	},

	maximize_rewards_sec: {
		label: 'Two Way Messaging',
		title: {
			one: 'Convenient',
			two: 'Asset',
			three: 'Request Service',
		},
		paragraph: {
			one: 'Convenient and easy-to-use, JPWorldPays request feature allows users to send and receive cryptocurrency effortlessly. With instant two-way messaging, you can communicate and confirm transactions in real-time, making the entire process smooth and efficient.',
		},
		cta_buttons: {
			one: 'Start Shopping',
		},
	},

	credit_system_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'Free ',
			two: 'Request Service',
			three: 'Without Hassle',
		},
		paragraph: {
			one: 'Once you request money from your friends using JPWorldPay, all you need to do is wait — the funds will be deposited automatically into your account. This hassle-free process ensures fast, secure, and convenient money transfers without any extra steps.',
		},
		cta_buttons: 'Get Started',
	},
	credit_system_right_sec: {
		label: 'Fastest Payment System',
		title: {
			one: 'Quick',
			two: '&',
			three: 'Easy',
			four: 'Setup',
			five: 'Process',
		},
		paragraph: {
			one: 'If your friend does not have a JPWorldPay account, all they need to do is sign up—it only takes a few minutes. The process is simple, fast, and gets them ready to send or receive payments right away. They can start enjoying secure and convenient transactions instantly.',
		},
		cta_buttons: 'Cash Card Info',
	},

	question_sec: {
		label: 'Salary Process',
		title: {
			one: 'It is Easy To',
			two: 'Send Salaries?',
		},
		paragraph: {
			one: 'Open the app and select "Receive Payment" to get started. This allows you to generate a QR code or share your payment details instantly, making it quick and easy for others to send you money securely.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},
	received_request_sec: {
		label: 'Select A JPWorldPay User',
		title: {
			one: 'Enter ',
			two: 'The Requested ',
			three: 'Amount',
		},
		paragraph: {
			one: 'You can simplify the daily reception of cryptocurrency by instantly creating a link to request assets through JPWorldPay. This streamlined process makes it easy to receive payments quickly and securely, allowing you to manage your transactions with ease. Stay in control of your finances and enjoy seamless transfers every time. With JPWorldPay, managing cryptocurrency has never been simpler.',
			two: 'With JPWorldPay, you can also track all your transactions in real-time, giving you full visibility over your financial activities. Whether you are sending or receiving payments, you will always know exactly where your funds are. Plus, with enhanced security features, your information is kept private and protected, ensuring peace of mind with every transaction. JPWorldPay also provides detailed transaction history, making it easy to review past payments and track spending.',
		},
		cta_buttons: {
			one: 'CREATING A JPWORLDPAY LINK',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
